import { UseFormReturn, useForm } from "react-hook-form";

import { DTOBuilding, DTOModule } from "../../types/building";
import WizardPage1 from "./WizardPage1";
import WizardPage2 from "./WizardPage2";
import WizardPage3 from "./WizardPage3";
import WizardPage4 from "./WizardPage4";
import { ModuleTypeId } from "../../types/DBTables";

interface IProps {
  building: DTOBuilding;
  wizardStep: number;
  formHook: UseFormReturn;
  remainingArea: number;
  onAddModule: (mt: ModuleTypeId) => void;
  onRemoveModule: (mId: Number) => void;
  onAddOmråde: (id: number, område: string) => void;
}

const ModuleEditor = ({ building, wizardStep, formHook, remainingArea, onAddModule, onRemoveModule, onAddOmråde }: IProps) => {
  const getModuleTypeConfigurator = () => {
    switch (wizardStep) {
      case 1:
        return <WizardPage1 formHook={formHook} building={building} remainingArea={remainingArea} onAddOmråde={onAddOmråde} />;
      case 2:
        return <WizardPage2 formHook={formHook} building={building} onAddModule={onAddModule} onRemoveModule={onRemoveModule} />;
      case 3:
        return <WizardPage3 building={building} formHook={formHook} onAddModule={onAddModule} onRemoveModule={onRemoveModule} />;
      case 4:
        return <WizardPage4 building={building} formHook={formHook} onAddModule={onAddModule} onRemoveModule={onRemoveModule} />;
      default:
        return <>Konfiguration hittades inte!</>;
    }
  };

  return <>{getModuleTypeConfigurator()}</>;
};

export default ModuleEditor;
